import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CHECKOUT_URL, pricing } from '../data/resinContent';
import { trackPixelEvent } from '../utils/metaPixel';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 640);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-294" data-mp="3ubak06nji4o6">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed bottom-0 left-0 right-0 z-40 w-full max-w-[100vw] border-t border-champagne/25 bg-charcoal-950/95 px-4 pb-[max(0.625rem,env(safe-area-inset-bottom))] pt-2.5 backdrop-blur lg:hidden" data-id="element-295" data-mp="3uegc7urgtmo4">
          <div className="mx-auto flex w-full max-w-md items-center justify-center gap-3" data-id="element-296" data-mp="75cgee760x46">
            <div className="shrink-0 leading-none" data-id="element-297" data-mp="27b0u38y7fxg">
              <p className="font-display text-2xl font-semibold text-ivory-50" data-id="element-298" data-mp="28m481yhelo1">
                {pricing.today}
                <span className="ml-1 align-middle font-sans text-[9px] font-semibold uppercase tracking-[0.12em] text-muted" data-id="element-299" data-mp="gxiabtgz9om0">
                  USD
                </span>
              </p>
              <p className="mt-1 text-[9px] uppercase tracking-[0.12em] text-muted" data-id="element-300" data-mp="pyggoiew287r">
                <span className="line-through" data-id="element-301" data-mp="lu8na7xhk437">{pricing.regularPrice}</span>
              </p>
            </div>
            <a href={CHECKOUT_URL} onClick={() => trackPixelEvent('InitiateCheckout', {
          content_name: 'RESIN TO PROFIT',
          value: pricing.todayValue,
          currency: 'USD'
        })} className="flex min-w-0 flex-1 items-center justify-center truncate whitespace-nowrap rounded-full bg-champagne px-3 py-3.5 text-center text-[11px] font-semibold uppercase leading-none tracking-[0.06em] min-[400px]:tracking-[0.1em] text-charcoal-950 transition-colors duration-150 ease-out active:bg-champagne-light" data-id="element-302" data-mp="ztrtuwanf7de">
              Get Resin to Profit™
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}